const cartItems = document.querySelector('[data-products]') ;
const upsellOptionsOverlay = document.querySelectorAll(`.cart-upsell-options-overlay`);
const upsellOptionsOverlayActive = document.querySelectorAll(`.cart-upsell-options-overlay.active`);
const drawerEmptyScrollable = document.querySelector('.drawer__cart-empty .cart-drawer__scrollable');

  function CSSOpenVariantsSelector (currentProductId) {
    const upsellOptions = document.querySelectorAll(`.cart-upsell-options`);
    upsellOptions.forEach((upsellOption) => {
        const upsellOptionId = parseInt(upsellOption.dataset.id);
        if(upsellOptionId === currentProductId) {
            upsellOption.style.transform = 'none';
            upsellOption.style.opacity = '1';
            upsellOption.style.display = 'block';
        }
    });
    if(document.querySelector('.drawer.is-empty .drawer__cart-empty') != null){
      document.querySelector('.drawer.is-empty .drawer__cart-empty').style.overflow = 'hidden';
    }
    upsellOptionsOverlay.forEach((overlay)=>{
      overlay.classList.add('active');
      overlay.style.transform = `translateY(-${upsellOptions.offsetHeight}px)`;
    });
    if(drawerEmptyScrollable != null){
      drawerEmptyScrollable.style.height = '100%';
    }
  }

  function CSSCloseVariantsSelector () {
    const upsellOptions = document.querySelectorAll(`.cart-upsell-options`);
    if(document.querySelector('.drawer.is-empty .drawer__cart-empty') != null){
      document.querySelector('.drawer.is-empty .drawer__cart-empty').style.overflow = 'visible';
    }
    upsellOptionsOverlay.forEach((overlay)=>{
      overlay.classList.remove('active');
    });


    upsellOptions.forEach((upsellOption) => {
        upsellOption.style.opacity = '0';
        upsellOption.style.transform = 'translateY(100%)';
        upsellOption.style.display = 'none';
    });
    if(drawerEmptyScrollable != null){
      drawerEmptyScrollable.style.height = 'auto';
    }
}

  function fetchSelectedOption (event) {
    const upsellOptions = document.querySelectorAll(`.cart-upsell-options`).forEach((upsellOption) => {
        upsellOption.style.transform = 'translateY(100%)';
        upsellOption.style.opacity = '0';
        upsellOption.style.display = 'none';
        });
      // fonction add to cart '/cart/add.js'


      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: event.dataset.current,
          quantity: 1,
        }),
      })
      .then((response) =>{

        //upsellOptionsOverlay.classList.remove('active');
        upsellOptionsOverlay.forEach((overlay)=>{
          overlay.classList.remove('active');
        });
        if(document.querySelector('.drawer.is-empty .drawer__cart-empty') != null){
        document.querySelector('.drawer.is-empty .drawer__cart-empty').style.overflow = 'visible';
        }
        upsellOptions;

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: response,
            addToCartBtn: event,
          }
        }));
      })
      .catch((error) => {
        console.error('Error:', error);
      });

  }

  function selectVariantsOnChange (HTMLDivCartUpsellOptions, selectedOption, lastSelectedOption) {
    const upsellSelectedOption = HTMLDivCartUpsellOptions.querySelector('.cart-action-add');
    const upsellSelectedImage = HTMLDivCartUpsellOptions.querySelector('.cart-upsell-image img');
    const HTMLArrayCartUpsellOption = HTMLDivCartUpsellOptions.querySelectorAll('.cart-upsell-option');

    HTMLArrayCartUpsellOption.forEach(() => {

      const variantsContainer = document.querySelectorAll('.cart-upsell-variant');

      variantsContainer.forEach((variant) => {
        const variantA11y = variant.dataset.a11y === 'true' ? true : false;
        const variantTitle = variant.dataset.title;
        
        const variantTitleArray = variantTitle.split(' / ');
        const variantTitleArray1 = variantTitleArray[0];
        const variantTitleArray2 = variantTitleArray.length > 1 ? variantTitleArray[1] : '';
      
        if (
          variant.dataset.productId.includes(HTMLDivCartUpsellOptions.dataset.id) &&
          (variantTitleArray1 === selectedOption || variantTitleArray1 === lastSelectedOption) &&
          (variantTitleArray.length === 1 || variantTitleArray2 === selectedOption || variantTitleArray2 === lastSelectedOption)
        ) {
          if (variantA11y === true) {
            upsellSelectedOption.removeAttribute("disabled");
          } else {
            upsellSelectedOption.setAttribute("disabled", true);
          }
          
          upsellSelectedOption.setAttribute('data-current', variant.dataset.variantId);
          upsellSelectedImage.src = variant.dataset.img;
        }
      });
        
    });
  }

//upsellOptionsOverlay.addEventListener('click', () => { CSSCloseVariantsSelector(); });
upsellOptionsOverlay.forEach((overlay)=>{
  overlay.addEventListener('click', () => { CSSCloseVariantsSelector(); });
});

let cartNoteDrawer = document.querySelector('#CartNoteDrawer');
document.querySelector('.CartNoteDrawer__label').addEventListener('click', function() {

  if(cartNoteDrawer.style.display === 'block') {
    cartNoteDrawer.style.display = 'none';
  } else {
    cartNoteDrawer.style.display = 'block';
  }

});